'use strict';

var util = require('../../util/property-util');
var arrayUtil = require('../../util/array-util');

module.exports = /*@ngInject*/ ["MessageDataFactory", "MessageDescriptorFactory", "MessageDataFilter", "MessageDataStructure", "$q", "$log", function (MessageDataFactory, MessageDescriptorFactory, MessageDataFilter, MessageDataStructure, $q, $log) {

    var msgStructure = new MessageDataStructure();
    var factory = {};

    /**
     * Gets the message data for the provided parameters.
     * Using this function with the useCache parameters set to true will
     * allow us to use the local cache for more efficient fetching
     * @param messageName   {String}    name of the message
     * @param trainId       {Number}    the relative id of the train
     * @param projectId     {Number}    the id of the project
     * @param from          {Number}    start time (MUST be epoch time, otherwise the cache won't work)
     * @param to            {Number}    end time (MUST be epoch time, otherwise the cache won't work)
     * @param rate          {Number}    data rate
     * @param useCache      {Boolean}   should we try to use the cache for fetching data?
     * @returns {*|promise.promise|Function|jQuery.promise|deferred.promise|{then, catch, finally}}
     */
    factory.getMessageData = function (messageName, trainId, projectId, from, to, rate, useCache, aggregate) {
        "use strict";

        var deferred = $q.defer();

        var cachedData = cache.get(messageName, trainId, projectId, from, to, rate);
        if (util.isDefined(cachedData) && useCache) {
            deferred.resolve(cachedData.data);
        } else {
            var queryParams = MessageDescriptorFactory.createMessageQueryParams(trainId, projectId, from, to, rate, aggregate);
            MessageDataFactory.getMessageData(messageName, queryParams, function (newData) {
                cache.save(messageName, trainId, projectId, from, to, rate, newData);
                deferred.resolve(newData);
            }, function () {
                deferred.reject("An error occurred while fetching data.");
            });
        }
        return deferred.promise;
    };

    factory.getLiveMessageData = function (messageName, trainId, projectId, from, to, rate) {
        "use strict";
        var deferred = $q.defer();
        var cachedData = cache.get(messageName, trainId, projectId, from, to, rate);
        var cacheFunction = cache.save;

        var newFrom = from;
        var newTo = to;

        if (util.isDefined(cachedData)) {
            var latestMessage = getLatestMessage(cachedData.data);
            if (util.isDefined(latestMessage)) {
                newFrom = latestMessage.timestamp; //- TimeZoneFactory.getOffset();
                cacheFunction = cache.update;
            }
        }

        if (newFrom < newTo) {
            var queryParams = MessageDescriptorFactory.createMessageQueryParams(trainId, projectId, newFrom, newTo, rate);
            MessageDataFactory.getMessageData(messageName, queryParams, function (newData) {
                var data = cacheFunction(messageName, trainId, projectId, from, to, rate, newData);
                //todo make sure all data is fetched
                deferred.resolve(data);
            }, function () {
                deferred.reject("An error occurred while fetching data.");
            });
        } else {
            $log.warn("newDate", new Date(newFrom), new Date(newTo));
            deferred.resolve([]);
        }


        return deferred.promise;
    };

    /**
     * Clears the cache for all messages
     */
    factory.clearCache = function () {
        cache.clear();
    };

    var getLatestMessage = function (data) {
        "use strict";
        if (data.length > 0) {
            return data[data.length - 1];
        } else {
            return undefined;
        }
    };

    var generateUniqueMessageEntryId = function (entry, messageName) {
        return MessageDataFilter.getUniqueEntryId(entry, messageName, msgStructure) + "_" + entry.timestamp;
    };


    var cache = {
        dataStorage: [],
        get: function (messageName, trainId, projectId, from, to, rate) {
            "use strict";
            var found = undefined;
            cache.dataStorage.some(function (entry) {
                if (entry.messageName == messageName && entry.trainId == trainId && entry.projectId == projectId && entry.from == from && entry.to == to && entry.rate == rate) {
                    found = entry;
                    return true;
                }
            });

            return found;
        },
        update: function (messageName, trainId, projectId, from, to, rate, data) {
            "use strict";
            var found = undefined;
            cache.dataStorage.some(function (entry) {
                if (entry.messageName == messageName && entry.trainId == trainId && entry.projectId == projectId) {
                    found = entry;
                    return true;
                }
            });

            if (util.isDefined(found)) {
                var newData = [];
                var filterTimestampList = function (value) {
                    return arrayUtil.getFirstInList(data, "timestamp", value.timestamp);
                };
                // get a list of cached data entries with the same timestamp as one of the new entries
                var filtered = found.data.filter(filterTimestampList);
                data.forEach(function (entry) {
                    var id = generateUniqueMessageEntryId(entry, messageName);
                    var foundEquals = filtered.some(function (filteredEntry) {
                        var filterId = generateUniqueMessageEntryId(filteredEntry, messageName);
                        return id == filterId;
                    });
                    if (!foundEquals) {
                        newData.push(entry);
                    }
                });

                found.data = found.data.concat(newData);
                return newData;
            } else {
                $log.warn("Updating a non cached message");
                return [];
            }

        },
        save: function (messageName, trainId, projectId, from, to, rate, data) {
            "use strict";
            var found = undefined;
            cache.dataStorage.some(function (entry) {
                if (entry.messageName == messageName && entry.trainId == trainId && entry.projectId == projectId) {
                    found = entry;
                    return true;
                }
            });

            if (util.isDefined(found)) {
                found.from = from;
                found.to = to;
                found.rate = rate;
                found.data = data;
            } else {
                var object = {
                    messageName: messageName,
                    trainId: trainId,
                    projectId: projectId,
                    from: from,
                    to: to,
                    rate: rate,
                    data: data
                };
                cache.dataStorage.push(object);
            }
            return data;
        },
        clear: function () {
            cache.dataStorage = [];
        }
    };

    return factory;
}];